module.exports = __webpack_public_path__ + "img/h4.cdc05a73.webp";